export default "__VITE_ASSET__afb3b4aa__"